import { TextInput } from '@mantine/core';
import { useCallback } from 'react';

/**
 * A reusable input component for variable names that validates against spaces
 * and provides suggestions for properly formatted variable names.
 */
export function VariableNameInput({
  value,
  onChange,
  error: externalError,
  label = 'Variable name',
  disabled = false,
  readOnly = false,
  autoFocus = false,
  placeholder = 'MY_VARIABLE',
  className,
  ...props
}: {
  value?: string;
  onChange: (value: string) => void;
  error?: React.ReactNode;
  label?: string;
  disabled?: boolean;
  readOnly?: boolean;
  autoFocus?: boolean;
  placeholder?: string;
  className?: string;
}) {
  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onChange(event.currentTarget.value);
    },
    [onChange],
  );

  return (
    <TextInput
      value={value}
      label={label}
      placeholder={placeholder}
      error={externalError}
      disabled={disabled}
      readOnly={readOnly}
      autoFocus={autoFocus}
      onChange={handleChange}
      className={className}
      {...props}
    />
  );
}
